import { Component, ViewEncapsulation, Input, forwardRef, Output, EventEmitter } from '@angular/core';
import { Frame, modal, noOp, language, date as DATE, popover, notification, async, color } from 'curvy';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TimePickerDialog } from './time-picker-dialog.component';


@Component({
    selector: 'task-time-picker-input',
    template: `
		<label colored-input
			class="input {{classes}}"
			[attr.title]="label | trans"
			[attr.color]="color"
			(click)="openTimePicker()">

			<input [placeholder]="'TIME_LABEL' | trans"
				[disabled]="disabled"
				[value]="getLabel(selected_value)"
				style="pointer-events: none; user-select: none"
				[required]="required"
				(focus)="openTimePicker()"
				inputmode="none"
                [readOnly]="true"
			/>

			<i icon="schedule" style="font-size: .7rem;"></i>
		</label>
	`,
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: TimePickerInput,
        multi: true
    }],
    styleUrls: ['./date-time-picker.scss'],
    encapsulation: ViewEncapsulation.None,

})

export class TimePickerInput implements ControlValueAccessor {
    private on_changed;
    private on_touched;


    @Input()
    classes: string = "outlined flex-dynamic";
    @Input()
    label: string = "TIME";
    @Input()
    color: string = "";
    @Input()
    required = false;
    @Input()
    disabled = false;
    @Input()
    format = "time";

    @Input()
    highlight = 'primary';

    @Input()
    title = 'TIME_LABEL';

    selected_value: Date | null = null;

    getLabel(date: Date | null): string {
        try {
            return this.write_date_value(date);
        } catch (err) {
            console.groupCollapsed("Error in to_label of task-time-picker-input element", this);
            console.error("Thrown error:", err);
            console.log("For value:", date);
            console.log("Defaulting to empty string.");
            console.groupEnd();
        }
        return "";
    }

    write_date_value(date: Date | null) {
        if (!date) {
            return '';
        } else {
            if (DATE.format_exists(this.format)) {
                return DATE.get_formatted_date(date, this.format, false);
            } else {
                return DATE.format(this.format, date, false);
            }
        }
    }

    openTimePicker() {
        popover.open(
            TimePickerDialog,
            (data) => {
                // console.log("ovo je u glavnom parentu došlo iz popupa", data);
                this.change(data);
            },
            { in_datetime: this.selected_value, highlight: this.highlight, title: this.title },
            noOp,
            "under-mouse", "auto", "date-time-popover-wrapper")
    }

    protected change(val: Date | null, perform_events = true) {
        if (this.disabled) return;
        this.selected_value = val;

        if (this.on_changed && perform_events) {
            this.on_changed(this.selected_value);
        }
    }

    writeValue(val: string | Date | null) {

        if (typeof val === 'string') this.selected_value = new Date(val);
        else this.selected_value = val;
    }

    registerOnChange(fn) {
        this.on_changed = fn;
    }

    registerOnTouched(fn) {
        this.on_touched = fn;
    }

    setDisabledState(state: boolean) {
        this.disabled = state;
    }
}

